import * as Sentry from '@sentry/react';
import { applicationSettings } from '../../../settings/application';
import platform from '../../../util/platform';

function getLongTermId() {
  const longTermId = localStorage.getItem('long_term_id');

  if (!longTermId) {
    return null;
  }
  const { id } = JSON.parse(longTermId);
  return id;
}

function create_UUID() {
  var dt = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
    /[xy]/g,
    function (c) {
      var r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    }
  );
  return uuid;
}

function getCachedPac() {
  if (
    localStorage.getItem('cachedPac-' + applicationSettings.applicationName) !==
    null
  ) {
    return localStorage.getItem(
      'cachedPac-' + applicationSettings.applicationName
    );
  }
  return null;
}

function getComputerId() {
  const url = window.location.href;
  const query = url.split('&');
  const computerIdQuery = query.find(string => string.includes('computerId='));

  if (!computerIdQuery) return;

  const computerId = computerIdQuery.split('=');
  return computerId[1];
}

function init() {
  const locale = applicationSettings.locale;
  // We aren't allowed to send Sentry data when application has a chinese locale
  if (locale === 'en-CN' || locale === 'zh-CN') {
    return false;
  }

  const isProduction = applicationSettings.isProd;
  Sentry.setUser({ id: getLongTermId() || create_UUID() });
  Sentry.setTag('application', applicationSettings.applicationName);
  if (getComputerId()) {
    Sentry.setTag('computerId', getComputerId());
  }
  Sentry.init({
    dsn: 'https://487b61e0c18344ed840ec085946bfa10@o514642.ingest.sentry.io/5944662',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.captureConsoleIntegration({ levels: ['error'] }),
    ],
    beforeSend: (event, hint) => {
      const cachedPac = getCachedPac();

      // This part is used to remove certain errors that occur on kiosk
      // Where they haven't stopped using the old gallery, even if it doesn't work anymore.
      if (platform.isKiosk) {
        if (
          event.message?.includes(
            'Invalid prop `type` supplied to `KompisIconButton`'
          )
        )
          return null;
        const values = event.exception?.values;
        const url = event.request?.url;
        if (values && url) {
          const serviceExceptionError = values.find(error => {
            const value = error.value;
            if (value) {
              return (
                value.includes(
                  'Uncaught ServiceException: Server responded with 404'
                ) ||
                value.includes(
                  'Failed to get app localizations. "ServiceSettings.applicationName"'
                )
              );
            }
            return false;
          });
          const hascComputerId = url.includes('computerId=RETCA313-KW');

          if (serviceExceptionError && hascComputerId) {
            return null;
          }
        }
      }

      if (cachedPac !== null) {
        hint.attachments = [
          {
            filename: 'cachedLocalstorage.txt',
            data: cachedPac,
          },
        ];
      }
      return event;
    },

    ignoreErrors: [
      /Cannot tween a null target./, // This error sometimes appear after screensaver ends and it doesn't affect the user
      /ResizeObserver loop limit exceeded/, // This error can occur when changing iframe size but it doesn't affect the user
      /Skapa Web Component!/, // This error is not something we can solve and doesn't seem to affect the user
      /^TypeError: Failed to fetch$/, // This error is not something we can solve from our end, this seems to only affect the insights data we try to send
      /Failed to send \w+ event/, // This error is not something we can solve from our end, this seems to only affect the insights data we try to send
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    environment: isProduction ? 'production' : 'development',
    tracesSampleRate: isProduction ? 0.3 : 1.0,
    release: `${applicationSettings.applicationVersion}`,
    normalizeDepth: 10,
  });
}

export default {
  init,
};
